import { Injectable } from '@angular/core';
import { FormArray, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CommonFunctionsService {

  constructor() { }

  convertToUtc(date: Date): Date {
    // Converts a local datetime to a UTC datetime by countering the timezone offset.
    // For example, offsets the UTC-6 so that 2/12/2026 07:00:00 (UTC-6) will arrive as 2026-02-12T07:00:00.000+00:00 in a MongoDB database on the backend.

    const utcDate = new Date(date);
    
    utcDate.setMinutes(utcDate.getMinutes() - utcDate.getTimezoneOffset());

    return utcDate;
  }

  convertToUtcEod(date: Date): Date {
    // Converts a local datetime to a UTC datetime by countering the timezone offset, and sets hours, minutes, seconds to 11:59:59.999.
    // For example, offsets the UTC-6 so that 2/12/2026 07:00:00 (UTC-6) will arrive as 2026-02-12T23:59:59.999+00:00 on the backend.

    const utcDate = new Date(date);
    
    utcDate.setHours(23, 59, 59, 999);
    utcDate.setMinutes(utcDate.getMinutes() - utcDate.getTimezoneOffset());  
    return utcDate;
  }

  combineDateAndTime(date: Date, time: Date): Date {
    // Combines a date and time into a single Date object, using the date's year/month/day and the time's hours/minutes/seconds
    const combined = new Date(date);
    combined.setHours(time.getHours());
    combined.setMinutes(time.getMinutes());
    combined.setSeconds(time.getSeconds());
    combined.setMilliseconds(time.getMilliseconds());
    return combined;
  }

  formatTimeOfDay(time: Date): string {
    // Formats a time-of-day Date (e.g. from a Material timepicker) as a 12-hour clock string, "h:mm AM/PM".
    return time.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
  }

  atLeastOneCheckedValidator(min = 1): ValidatorFn {
    return (control: FormArray) => {
      const checkedCount = control.controls
        .map(ctrl => ctrl.value)
        .filter(Boolean)
        .length;

      return checkedCount >= min
        ? null
        : { atleastonerequired: true };
    };
  }

  translateOfficeLabel(office: string): string {
    switch (office) {
      case 'Houston': return 'houston';
      case 'Ft. Worth': return 'ftworth';
      case 'Austin': return 'austin';
      case 'Irving': return 'irving';
      case 'Frisco': return 'frisco';
      case 'Bossier City': return 'bossiercity';
      case 'Magnolia': return 'magnolia';
      case 'Windsor': return 'windsor';
      case 'Midland': return 'midland';
      case 'Phoenix': return 'phoenix';
    default: return office;
  }
}

  translateOfficeLabelReverse(office: string): string {
    switch (office) {
      case 'houston': return 'Houston';
      case 'ftworth': return 'Ft. Worth';
      case 'austin': return 'Austin';
      case 'irving': return 'Irving';
      case 'frisco': return 'Frisco';
      case 'bossiercity': return 'Bossier City';
      case 'magnolia': return 'Magnolia';
      case 'windsor': return 'Windsor';
      case 'midland': return 'Midland';
      case 'phoenix': return 'Phoenix';
      default: return office;
    }
  }
}
